// The 16 soil values stored on a report. Ideal ranges follow the recommendation engine
// (generateRecommendation_v2) and the farmer report; no range means no status is shown.
export const SOIL_PARAMETERS = [
  { key: 'ph', label: 'pH', unit: '', min: 6.5, max: 7.5, low: 'Acidic', high: 'Alkaline' },
  { key: 'ec', label: 'Electrical conductivity (EC)', unit: 'dS/m', min: 0.8, max: 2.0 },
  { key: 'oc', label: 'Organic carbon (OC)', unit: '%', min: 0.5, max: 0.75 },
  { key: 'nitrogen', label: 'Nitrogen (N)', unit: 'kg/ha', min: 280, max: 560 },
  { key: 'nitrate', label: 'Nitrate (NO₃)', unit: '' },
  { key: 'ammonia', label: 'Ammonia (NH₄)', unit: '' },
  { key: 'phosphorus', label: 'Phosphorus (P)', unit: 'kg/ha', min: 10, max: 25 },
  { key: 'potassium', label: 'Potassium (K)', unit: 'kg/ha', min: 110, max: 280 },
  { key: 'sulphur', label: 'Sulphur (S)', unit: 'mg/kg', min: 10, max: 20 },
  { key: 'magnesium', label: 'Magnesium (Mg)', unit: 'ppm', min: 180, max: 540 },
  { key: 'calcium', label: 'Calcium (Ca)', unit: 'ppm', min: 400, max: 1200 },
  { key: 'zinc', label: 'Zinc (Zn)', unit: 'mg/kg', min: 0.5, max: 1.0 },
  { key: 'iron', label: 'Iron (Fe)', unit: 'mg/kg', min: 5, max: 10 },
  { key: 'manganese', label: 'Manganese (Mn)', unit: 'mg/kg' },
  { key: 'copper', label: 'Copper (Cu)', unit: 'mg/kg', min: 0.2, max: 0.4 },
  { key: 'boron', label: 'Boron (B)', unit: 'mg/kg', min: 0.1, max: 0.5 },
];

const isBelowDetection = (value) => String(value ?? '').trim().toUpperCase() === 'BODL';

export const parameterStatus = (param, value) => {
  if (param.min == null || value == null || String(value).trim() === '') return null;
  if (isBelowDetection(value)) return 'low';
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  if (n < param.min) return 'low';
  if (n > param.max) return 'high';
  return 'ok';
};

export const statusLabel = (param, status) => {
  if (status === 'low') return param.low || 'Low';
  if (status === 'high') return param.high || 'High';
  if (status === 'ok') return 'Ideal';
  return '';
};

export const displayValue = (value) => {
  if (value == null || String(value).trim() === '') return '—';
  return isBelowDetection(value) ? 'Below detection' : String(value).trim();
};

// Up to three parameters outside their ideal range, in report order.
export const fixFirst = (parameters, max = 3) => {
  if (!parameters) return [];
  return SOIL_PARAMETERS
    .map((param) => ({ param, status: parameterStatus(param, parameters[param.key]) }))
    .filter(({ status }) => status === 'low' || status === 'high')
    .slice(0, max)
    .map(({ param, status }) => ({ key: param.key, label: param.label, status: statusLabel(param, status) }));
};
